// src/pages/UserWelcome.jsx
import React from "react";
import { useNavigate, Outlet } from "react-router-dom";
import "../style/UserWelcome.css";

const UserWelcome = ({ onLogout }) => {
  const navigate = useNavigate();
  const role = localStorage.getItem("role") || "user";

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("username");
    onLogout();
    navigate("/login");
  };

  const isTransportadora = role === "transportadora";
  const isAdmin = role === "admin";

  return (
    <div className="main-container">
      <aside className="sidebar">
        <h1>📈 Market Busters</h1>
        <nav>
          <ul>
            {/* Solo admin/user */}
            {!isTransportadora && (
              <>
                <li onClick={() => navigate("/importar")}>📤 Importar</li>
                <li onClick={() => navigate("/informes")}>📊 Informes</li>
                <li onClick={() => navigate("/informe-30dias")}>🗓️ Informe 30 Días</li>
                <li onClick={() => navigate("/inteligencia-artificial")}>🤖 Inteligencia Artificial</li>
                <li onClick={() => navigate("/graficos")}>📉 Gráficos</li>
                <li onClick={() => navigate("/tendencias")}>📈 Tendencias</li>
                <li onClick={() => navigate("/telegram")}>📲 Telegram</li>
              </>
            )}

            {/* Transportadora y admin */}
            {(isAdmin || isTransportadora) && (
              <li onClick={() => navigate("/transportadora")}>🚚 Transportadora</li>
            )}

            {/* Dropdrop: solo admin */}
            {isAdmin && (
              <li onClick={() => navigate("/dropdrop")}>🛒 Dropdrop</li>
            )}
          </ul>
        </nav>
        <button className="logout-button" onClick={handleLogout}>
          🚪 Cerrar Sesión
        </button>
      </aside>
      <div className="content">
        <Outlet />
      </div>
    </div>
  );
};

export default UserWelcome;
